import React, { Component } from 'react'
import { Text } from 'react-localizer'
import { Col, Grid, Row } from 'react-bootstrap'
import LockThePlaceResults from './LockThePlaceResults'
import '../../css/LockThePlace.css'

class LockThePlace extends Component {

  constructor (props) {
    super(props)

    // Fetch local storage if set
    const pfToEarn = localStorage.getItem('pfToEarn') ? localStorage.getItem('pfToEarn') : ''
    const maxPf = localStorage.getItem('maxPf') ? localStorage.getItem('maxPf') : ''
    const totalPfPut = localStorage.getItem('totalPfPut') ? localStorage.getItem('totalPfPut') : ''
    const pfToOvertake = localStorage.getItem('pfToOvertake') ? localStorage.getItem('pfToOvertake') : ''
    const theArcBonus = localStorage.getItem('theArcBonus') ? localStorage.getItem('theArcBonus') : 100
    const ownPfLaid = localStorage.getItem('ownPfLaid') ? localStorage.getItem('ownPfLaid') : ''
    const label = localStorage.getItem('label') ? localStorage.getItem('label') : ''

    //define initial state
    this.state = {
      pfToEarn: pfToEarn,
      maxPf: maxPf,
      totalPfPut: totalPfPut,
      pfToOvertake: pfToOvertake,
      theArcBonus: theArcBonus,
      ownPfLaid: ownPfLaid,
      label: label
    }
  }

  static setLocalStorage (itemName, value) {
    localStorage.setItem(itemName, value)
  }

  handleMaxPfChanged (event) {
    LockThePlace.setLocalStorage('maxPf', event.target.value)
    this.setState({
      maxPf: event.target.value
    })
  }

  render () {
    return (
      <div id={'lockThePlace'}>
        {/*<div className="filters">*/}
        <form className="App-form">
          <div className="App-form-group">
            <Grid>
              <Row className="show-grid">
                <Col md={6} xs={12}>
                  <label htmlFor={'maxPf'}><Text>lockThePlace.maxPf</Text></label>
                  <input tabIndex={10} name={'maxPf'} id={'maxPf'} type={'number'} min={0} max={10000}
                         value={this.state.maxPf} required className={'data-hj-allow'}
                         onChange={(event) => this.handleMaxPfChanged(event)}>
                  </input>
                </Col>

                <Col md={6} xs={12}>
                  <label htmlFor={'totalPfPut'}><Text>lockThePlace.totalPfPut</Text></label>
                  <input tabIndex={40} name={'totalPfPut'} id={'totalPfPut'} type={'number'} min={0} max={10000}
                         value={this.state.totalPfPut} required className={'data-hj-allow'}
                         onChange={(event) => this.handleTotalPfPutChanged(event)}>
                  </input>
                </Col>

              </Row>

              <Row className="show-grid">
                <Col md={6} xs={12}>
                  <label htmlFor={'pfToOvertake'}><Text>lockThePlace.pfToOvertake</Text></label>
                  <input tabIndex={20} name={'pfToOvertake'} id={'pfToOvertake'} type={'number'} min={0} max={10000}
                         value={this.state.pfToOvertake} required className={'data-hj-allow'}
                         onChange={(event) => this.handlePfToOvertakeChanged(event)}>
                  </input>
                </Col>

                <Col md={6} xs={12}>
                  <label htmlFor={'pfToEarn'}><Text>lockThePlace.pfToEarn</Text></label>
                  <input tabIndex={50} name={'pfToEarn'} id={'pfToEarn'} type={'number'} min={0} max={10000} step={5}
                         value={this.state.pfToEarn} required className={'data-hj-allow'}
                         onChange={(event) => this.handlePfToEarnChanged(event)}>
                  </input>
                </Col>
              </Row>

              <Row className="show-grid">
                <Col md={6} xs={12}>
                  <label htmlFor={'theArcBonus'}><Text>lockThePlace.yourArcBonus</Text></label>
                  <input tabIndex={30} name={'theArcBonus'} id={'theArcBonus'} type={'number'} min={100} max={200} step={0.5}
                         value={this.state.theArcBonus} required className={'data-hj-allow'}
                         onChange={(event) => this.handleTheArcBonusChanged(event)}>
                  </input>
                </Col>

                <Col md={6} xs={12}>
                  <label htmlFor={'ownPfLaid'}><Text>lockThePlace.ownPfLaid</Text></label>
                  <input tabIndex={60} name={'ownPfLaid'} id={'ownPfLaid'} type={'number'} min={0} max={10000}
                         value={this.state.ownPfLaid} required className={'data-hj-allow'}
                         onChange={(event) => this.handleOwnPfLaidChanged(event)}>
                  </input>
                </Col>
              </Row>

              <Row className="show-grid">
                <Col mdOffset={3} md={6} xs={12} id={'label'}>
                  <label htmlFor={'label'}><Text>lockThePlace.label</Text></label>
                  <input tabIndex={100} name={'label'} type={'text'} maxLength={30}
                         value={this.state.label} required className={'data-hj-allow'}
                         onChange={(event) => this.handleLabelChanged(event)}>
                  </input>
                </Col>
              </Row>

              {/*             <Row className="show-grid">
                <Col xs={6}>
                  <Button
                    onClick={(event) => this.handleEraseInput(event)}
                    bsStyle="danger"
                    bsSize="large">
                    Vider les champs</Button>
                </Col>
                <Col xs={6}>

                </Col>
              </Row>*/}


            </Grid>
          </div>
        </form>
        {/*</div>*/}
        <div>

          {this.inputsAreFilled() &&
          <LockThePlaceResults choices={this.state}/>}

        </div>
      </div>
    )
  }

  /**
   * Check if all inputs has been filled by the user
   * @returns {boolean}
   */
  inputsAreFilled () {

    return ('' !== this.state.pfToEarn
      && '' !== this.state.maxPf
      && '' !== this.state.totalPfPut
      && '' !== this.state.pfToOvertake
      && '' !== this.state.ownPfLaid
      && '' !== this.state.theArcBonus)
  }

  handleTotalPfPutChanged (event) {
    LockThePlace.setLocalStorage('totalPfPut', event.target.value)
    this.setState({
      totalPfPut: event.target.value
    })
  }

  handlePfToOvertakeChanged (event) {
    LockThePlace.setLocalStorage('pfToOvertake', event.target.value)
    this.setState({
      pfToOvertake: event.target.value
    })
  }

  handlePfToEarnChanged (event) {
    LockThePlace.setLocalStorage('pfToEarn', event.target.value)
    this.setState({
      pfToEarn: event.target.value
    })
  }

  handleTheArcBonusChanged (event) {
    LockThePlace.setLocalStorage('theArcBonus', event.target.value)
    this.setState({
      theArcBonus: event.target.value
    })
  }

  handleLabelChanged (event) {
    LockThePlace.setLocalStorage('label', event.target.value)
    this.setState({
      label: event.target.value
    })
  }

  handleOwnPfLaidChanged (event) {
    LockThePlace.setLocalStorage('ownPfLaid', event.target.value)
    this.setState({
      ownPfLaid: event.target.value
    })
  }

  /*  handleEraseInput (event) {
      this.setState = {
        pfToEarn: null,
        maxPf: null,
        totalPfPut: null,
        pfToOvertake: null,
        theArcBonus: null,
        label: null
      }
    }*/
}

export default LockThePlace



// WEBPACK FOOTER //
// ./src/components/LockThePlace/LockThePlace.js